// extracted by mini-css-extract-plugin
export default {"Head":"review_Head__xNUTk","Heading":"review_Heading__5W-ww","P":"review_P__7qHmb","Reviews":"review_Reviews__nIrD5","Spl":"review_Spl__LioK5","IMG":"review_IMG__Fm7F9"};